import React from 'react'

export default function PresidentWord() {
    return (
        <div className='container '>
            <div className='row rtl'>
                <div className='col-lg-12 col-md-12 col-sm-12'>
                    <h3 className='NewsPostTitle bold'>
                        كلمة المدير العام للجمعية
                    </h3>
                </div>

                <div className='col-lg-12 col-md-12 col-sm-12 my-3'>
                    <div className='NewsPostBody' >
                        نسعى بكلّ جهد لتطوير منظومة الفروسية والخيل العربية كأحد مفردات تراثنا العربي الأصيل، ونفخر أننا في دولة الإمارات، ومن خلال "جمعية الإمارات للخيول العربية" بنجاحنا في تطوير منظومة مُتكاملة لتطوير هذا القطاع عبر الارتقاء بالأداء، مُلتزمين في ذلك بالابتكار والجودة والتميّز.

                        تسعى الجمعية إلى تعزيز حضورها الإلكتروني بما يتماشى مع التطورات المُتسارعة التي تشهدها الدولة والمجتمع في مجالات التقنية، وتهدف إلى تعريف الملاك والمُربّين وعشّاق الخيول العربية برؤيتها ورسالتها وأهدافها، مع تسليط الضوء على مشروعاتها وبرامجها وخدماتها المخصّصة لدعم قطاع الملاك والمُربّين والمُهتمّين بالخيول العربية، كما تعمل الجمعية على تنظيم فعاليات وأنشطة متنوّعة، تعكس التزامها بتطوير هذا القطاع الحيوي وتعزيز ارتباطه بالإرث الثقافي والتراثي.

                        تتمثّل الرسالة الرئيسة لـ"جمعية الإمارات للخيول العربية"، في تطوير سلالات الخيل العربية ورفع شأنها عالميًا، ولعبت الجمعية منذ تأسيسها سنة 1989 دورًا في عملية تسجيل الخيول العربية، والدفاع عن هويتها، وإعطائها مكانتها التي تستحقّها محليًا ودوليًا، فضلًا عن تنظيم مسابقات عروض الجمال وكلّ الأنشطة المُرتبطة بها داخل الدولة وخارجها والإشراف عليها، وذلك لإبراز الجانب الجمالي لها، كما تهتمّ الجمعية بالمُربّين والملاك وزيادة قاعدتهم وتشجيعهم عبر الحوافز والجوائز القيّمة خلال تلك البطولات.
                    </div>
                </div>
                <div className='col-lg-12 col-md-12 col-sm-12'>
                    <h6 className='NewsPostTitle bold text-end'>
                        محمد أحمد الحربي
                    </h6>
                    <h6 className='NewsPostTitle bold text-end'>
                        مدير عام جمعية الإمارات للخيول العربية
                    </h6>
                </div>
            </div>
        </div>
    )
}
